export var AggregationItemType;
(function (AggregationItemType) {
    /**Averages the item over the period (floating point values).*/
    AggregationItemType["MEAN"] = "MEAN";
    /**Sums the item over the period (integral values only).*/
    AggregationItemType["TOTAL"] = "TOTAL";
})(AggregationItemType || (AggregationItemType = {}));
//# sourceMappingURL=AggregTypes.js.map